import React, {useState} from "react";
import SlideData, {UploadStatus} from "../../../Interfaces/SlideData";
import {Image} from "react-bootstrap";
import Loader from "../../Common/Loader";

interface SlidesPopupItemProps {
    data: SlideData,
    onRotateSlide: (e: React.MouseEvent<HTMLElement>, slideData: SlideData) => void,
    onEditSlide: (e: React.MouseEvent<HTMLElement>, slideData: SlideData) => void,
    onDeleteSlide: (e: React.MouseEvent<HTMLElement>, slideData: SlideData) => void,
}

const SlidesPopupItem: React.FC<SlidesPopupItemProps> = ({
                                                             data,
                                                             onRotateSlide,
                                                             onEditSlide,
                                                             onDeleteSlide
                                                         }) => {
    const [isActionStubVisible, setActionStubVisible] = useState(data?.status != UploadStatus.uploadError);

    return (
        <div className={`slidesPopupItem ${data.type}`}>
            <div>
                {
                    (data.status == UploadStatus.ready) ?
                        (
                            <Image
                                src={data.src}
                                className={`imageFitContainer ${isActionStubVisible ? 'blur5' : ''}`}
                                onLoad={() => {
                                    setActionStubVisible(false)
                                }}
                            >
                            </Image>
                        ) : ''
                }

                {
                    (data.status == UploadStatus.uploadError) ?
                        (
                            <div className={'upload-error-container'}>
                                <div className={'upload-error'}>
                                    <div className={'upload-error-text'}>{data.uploadError}</div>
                                    <div className={'local-file-name'}>{data.localFileName}</div>
                                </div>
                            </div>
                        ) : ''
                }

                <div className={'controls'} style={isActionStubVisible ? {display: 'none'}: {display: 'block'}}>
                    <div className={'control delete'}
                         onClick={(e: React.MouseEvent<HTMLElement>) => onDeleteSlide(e, data)}>
                        <i className={'fa fa-trash-alt'}></i>
                    </div>
                    {
                        /* Открытки-картинки нельзя вращать. если src содержит .slide-life.ru/cards/ - значит это открытка-картинка */
                        data.type == 'photo'  &&
                        data.status == UploadStatus.ready &&
                        !data.src?.includes('.slide-life.ru/cards/') ?
                            (<div className={'control rotate'}
                                  onClick={(e: React.MouseEvent<HTMLElement>) => {
                                      setActionStubVisible(true);
                                      onRotateSlide(e, data);
                                  }}>
                                <i className={'fa fa-redo'}></i>
                            </div>) : ''
                    }

                    {
                        data.type == 'text' && data.status == UploadStatus.ready ?
                            (<div className={'control edit'}
                                  onClick={(e: React.MouseEvent<HTMLElement>) => {
                                      // setActionStubVisible(true);
                                      onEditSlide(e, data);
                                  }}>
                                <i className={'fa fa-pen'}></i>
                            </div>) : ''
                    }
                </div>
            </div>
            <Loader isLoaded={!isActionStubVisible || (data.type == 'text' && data.status == UploadStatus.uploading)}
                    background={'#00000059'}/>
            {
                isActionStubVisible || (data.type == 'text' && data.status == UploadStatus.uploading) ?
                    <Loader showProgress={false}
                            isLoaded={false}
                            isPositionAbsolute={true}
                            background={'transparent'}/> : ''
            }
        </div>
    )
}

export default SlidesPopupItem;